import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


export const LicenseSectionSkeleton = () => (
    <FormSection
        headline="License"
        info={() => (
            <Item grow={1}>
                <Group justify="space-between" alignItems="center">
                    <Group gap="s" alignItems="center">
                        <SkeletonItem width={75} height={28}/>
                        <SkeletonItem width={75} height={28}/>
                    </Group>
                    <SkeletonItem width={82} height={32}/>
                </Group>
            </Item>
        )}>
        <Group direction="v" alignItems="start">
            <Group gap="l">
                <Item style={{width: 120}}><SkeletonItem width={90} height={17}/></Item>
                <SkeletonItem width={170} height={17}/>
            </Group>
            <Group gap="l">
                <Item style={{width: 120}}><SkeletonItem width={90} height={17}/></Item>
                <SkeletonItem width={55} height={17}/>
            </Group>
        </Group>
    </FormSection>
);
